module.exports = __webpack_public_path__ + "static/media/long-arrow-black.0226fc57.svg";